export default "__VITE_ASSET__DAb$KqKg__"